<template>
  <b-modal
    :visible="visible"
    hide-footer
    size="md"
    @hide="$emit('close')"
  >
    <template #modal-header>
      <div class="d-flex w-100 border-bottom pb-2">
        <h2 class="mb-0 w-100 text-left">{{ vehicle.name || 'Veículo' }}</h2>
        <button
          type="button"
          class="close"
          aria-label="Fechar"
          @click.prevent="$emit('close')"
        >
          <span class="no no-e-remove"></span>
        </button>
      </div>
    </template>

    <div v-if="vehicle" class="vehicle-details">
      <img
        :src="vehicle.image"
        :alt="vehicle.name"
        class="vehicle-details-image"
      />
      <dl class="vehicle-details-list">
        <div>
          <dt>Categoria</dt>
          <dd>{{ vehicle.category || '—' }}</dd>
        </div>
        <div>
          <dt>Tipo</dt>
          <dd>{{ vehicle.type || '—' }}</dd>
        </div>
        <div>
          <dt>Placa</dt>
          <dd>{{ vehicle.plate || '—' }}</dd>
        </div>
        <div>
          <dt>Capacidade</dt>
          <dd>{{ capacityLabel }}</dd>
        </div>
        <div>
          <dt>Descrição</dt>
          <dd>{{ vehicle.description || '—' }}</dd>
        </div>
      </dl>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'VehicleDetailsModal',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    vehicle: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    capacityLabel() {
      const count = Number(this.vehicle && this.vehicle.capacity) || 0
      return count === 1 ? '1 pessoa' : `${count} pessoas`
    },
  },
}
</script>

<style>
.vehicle-details-image {
  display: block;
  width: 100%;
  max-height: 220px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 1rem;
  background: #f3f4f6;
}

.vehicle-details-list {
  margin: 0;
}

.vehicle-details-list > div {
  display: flex;
  gap: 0.75rem;
  padding: 0.45rem 0;
  border-bottom: 1px solid #eef2f4;
}

.vehicle-details-list dt {
  width: 7rem;
  margin: 0;
  color: #12576e;
  font-weight: 700;
}

.vehicle-details-list dd {
  margin: 0;
  color: #3b4654;
}
</style>
